import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import renderViewsState from '../shared/render-views-state';

import Popup from './components/popup-order';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

lessRequire('modules/bm-accounts/item.less');

const Main = renderViewsState(props => {
	const {intl} = props;
	const accountData = props.accountDataSelector(props.params.id);
	return !!accountData && (
		<div className="container__with-columns container bm-item__container">
			<div className="container__content">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">
						{intl('Купить') + ` ${accountData.name}`}
					</h2>
				</div>
				<div className="container content-container">
					<div className="picture__block">
						<div
							className="account__image"
							style={
								accountData.image
									? {backgroundImage: `url('${accountData.image}')`, backgroundSize: 'contain'}
									: {}
							}
						></div>
						<button
							className="button yellow-btn font-proxima-nova-semibold"
							onClick={() => props.initPopup(props.params.id)}
						>
							{intl('Купить')}
						</button>
					</div>
					<div className="description__container">
						<span> {accountData.description} </span>
					</div>
				</div>
				<Popup {...props} isOpen={props.isOpenPopup} popupAccountData={accountData}/>
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		accountDataSelector: selectors.getAccountDataSelector(state),
		popupAccountData: selectors.getPopupAccountData(state),
		popupType: selectors.getPopupType(state),
		isOpenPopup: selectors.getIsOpenPopup(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/bm-accounts/item.js